import React from "react";

function SearchResultsNotFound() {
  return (
    <div className="d-flex flex-column align-items-center my-5">
      <div className="d-flex flex-column align-items-center">
        <img
          src="https://static.hsappstatic.net/ui-images/static-2.422/optimized/empty-state-charts.svg"
          alt="Empty State Chart"
        />
        <p className="search-not-found-para mt-4">No mappings found.</p>
        <p className="search-not-found-para">Try changing your filters.</p>
      </div>
    </div>
  );
}

export default SearchResultsNotFound;
